import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-grow grid grid-cols-2 gap-4 w-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-center" }

import {onMounted, ref} from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {DisdiService} from "@/utilities/services/entities/DisdiService";
import {ErrorLocationType} from "@/utilities/enums/Enums";



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiAttachmentTab',
  props: {
  data: Object
},
  setup(__props) {

const props = __props

const disdiService = new DisdiService();

const loading = ref<boolean>(false);
const attachmentUrlList = ref<Array<string>|null>(null);



onMounted(async()=>{
  loading.value = true;
  attachmentUrlList.value = await disdiService.getAttachments(props.data.id, ErrorLocationType.popup);
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentUrlList.value, (url) => {
          return (_openBlock(), _createElementBlock("div", { key: url }, [
            _createElementVNode("img", { src: url }, null, 8, _hoisted_2)
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, loading.value]
    ])
  ], 64))
}
}

})